import { render, staticRenderFns } from "./decoration-reply-refer-form.vue?vue&type=template&id=6edde8f8&scoped=true&"
import script from "./decoration-reply-refer-form.vue?vue&type=script&lang=js&"
export * from "./decoration-reply-refer-form.vue?vue&type=script&lang=js&"
import style0 from "./decoration-reply-refer-form.vue?vue&type=style&index=0&id=6edde8f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edde8f8",
  null
  
)

export default component.exports